import Foursquare from "~/img/powered-by-foursquare.png";
import { Stack } from "./Stack";
import { Inline } from "./Inline";

export const Footer = () => {
  return (
    <div
      style={{
        fontSize: "14px",
        fontWeight: 300,
        margin: "15px auto -45px",
        padding: "20px 20px 50px",
        textAlign: "center",
        width: "100%",
        backgroundColor: "var(--yellow)",
        transform: "skew(0deg, -2deg)",
      }}
    >
      <div style={{ transform: "skew(0deg, 2deg)" }}>
        <Stack>
          <Inline separator="•">
            <Inline>
              <span title="I think I'll still drink coffee in [current year].">
                &copy; {new Date().getFullYear()}
              </span>
              <a
                href="https://kylorhall.com/"
                target="_blank"
                rel="noopener noreferrer"
                title="Kylor Hall's Personal Website"
              >
                Kylor Hall
              </a>
            </Inline>
            <a
              href="https://www.instagram.com/kylorhall/"
              target="_blank"
              rel="noreferrer noopener"
              title="Follow my Instagram for the rare photo."
            >
              Instagram
            </a>
            <a
              href="https://twitter.com/kylorhall/"
              target="_blank"
              rel="noreferrer noopener"
              title="Probably don't follow my dead Twitter."
            >
              Twitter
            </a>
          </Inline>
        </Stack>

        <a
          href="https://foursquare.com/kylorhall"
          target="_blank"
          rel="noreferrer noopener"
          title="Powered by Foursquare – using Swarm Checkins"
          style={{
            display: "block",
            width: 150,
            height: "auto",
            margin: "10px auto 0",
            textAlign: "center",
          }}
        >
          <img
            style={{ display: "block" }}
            src={Foursquare}
            alt="Powered by Foursquare – using Swarm Checkins"
            width="150"
          />
        </a>
      </div>
    </div>
  );
};
